import { render } from "./PerrySpecial.vue?vue&type=template&id=0bc2d463&scoped=true"
import script from "./PerrySpecial.vue?vue&type=script&lang=js"
export * from "./PerrySpecial.vue?vue&type=script&lang=js"

import "./PerrySpecial.vue?vue&type=style&index=0&id=0bc2d463&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bc2d463"]])

export default __exports__